import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddInstalledProductAttachmentsMutationVariables = Types.Exact<{
  objects: Array<Types.Installed_Product_Attachments_Insert_Input> | Types.Installed_Product_Attachments_Insert_Input;
}>;


export type AddInstalledProductAttachmentsMutation = { __typename?: 'mutation_root', insert_installed_product_attachments?: { __typename?: 'installed_product_attachments_mutation_response', returning: Array<{ __typename?: 'installed_product_attachments', id: any, installed_product_id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, name?: string | null, description?: string | null, created_at: any, updated_at: any }> } | null };


export const AddInstalledProductAttachmentsDocument = gql`
    mutation addInstalledProductAttachments($objects: [installed_product_attachments_insert_input!]!) {
  insert_installed_product_attachments(objects: $objects) {
    returning {
      id
      installed_product_id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      type
      name
      description
      created_at
      updated_at
    }
  }
}
    `;
export type AddInstalledProductAttachmentsMutationFn = Apollo.MutationFunction<AddInstalledProductAttachmentsMutation, AddInstalledProductAttachmentsMutationVariables>;

/**
 * __useAddInstalledProductAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddInstalledProductAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInstalledProductAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInstalledProductAttachmentsMutation, { data, loading, error }] = useAddInstalledProductAttachmentsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAddInstalledProductAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddInstalledProductAttachmentsMutation, AddInstalledProductAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInstalledProductAttachmentsMutation, AddInstalledProductAttachmentsMutationVariables>(AddInstalledProductAttachmentsDocument, options);
      }
export type AddInstalledProductAttachmentsMutationHookResult = ReturnType<typeof useAddInstalledProductAttachmentsMutation>;
export type AddInstalledProductAttachmentsMutationResult = Apollo.MutationResult<AddInstalledProductAttachmentsMutation>;
export type AddInstalledProductAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddInstalledProductAttachmentsMutation, AddInstalledProductAttachmentsMutationVariables>;